import { defineStore } from 'pinia';
import { RouteLocationNormalizedLoaded } from 'vue-router';

/**
 * 路由列表
 * @methods setRoutesList 设置路由数据
 */
export const useRoutesList = defineStore('routesList', {
	state: (): RoutesListState => ({
		routesList: [],
		currentRoute: {},
	}),
	actions: {
		async setRoutesList(data: Array<string>) {
			this.routesList = data;
		},
		setCurrentRoute(route: RouteLocationNormalizedLoaded) {
			this.currentRoute = route;
		  },
	},
});
